module.exports = __webpack_public_path__ + "static/img/6.cb51448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/6.jpg
// module id = rJro
// module chunks = 1